/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';

const styles = {
  customButtonContainer: 'customButtonContainer_91be4ced',
  icon: 'icon_91be4ced',
  themeDarkAltColor: 'themeDarkAltColor_91be4ced',
  leftText: 'leftText_91be4ced',
  splitter: 'splitter_91be4ced',
  button: 'button_91be4ced',
  darkerBG: 'darkerBG_91be4ced',
};

export = styles;

loadStyles([{"rawString":".customButtonContainer_91be4ced{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.icon_91be4ced{display:inline-block;font-family:FabricMDL2Icons;font-style:normal;font-weight:400;speak:none;font-size:14px;position:relative}.themeDarkAltColor_91be4ced{color:"},{"theme":"themeDarkAlt","defaultValue":"#106ebe"},{"rawString":"}.leftText_91be4ced{margin-left:6px;font-size:14px;font-weight:400;color:"},{"theme":"neutralPrimary","defaultValue":"#333333"},{"rawString":"}.splitter_91be4ced{font-size:14px;font-weight:400;color:"},{"theme":"neutralTertiary","defaultValue":"#a6a6a6"},{"rawString":";background:0 0;position:relative;top:-2px;height:40px}.button_91be4ced.ms-Button{height:40px;min-width:28px;padding:0 5px}.button_91be4ced:hover{background:initial}.darkerBG_91be4ced{background:#d0d0d0}"}]);
/* tslint:enable */